$(document).ready(function() {

	$(document).on('click', '#product-request-offer', function (e) {
		e.preventDefault();

		const url = $(this).data('url');

		var urlParams = '?p=' + encodeURIComponent($(this).data('id'));

		if ($('#surface').val() != '') {
			urlParams += '&surface=' + encodeURIComponent($('#surface').val());
		}
		if ($('#thickness option:selected').val() != '') {
			urlParams += '&thickness=' + encodeURIComponent($('#thickness option:selected').val());
		}

		window.location = url + urlParams;
	});

});
